import http from 'core/services/http';
import Config from 'core/config';

class SendEmailService {
  static getUserEvents(userId) {
    return http.get(`${Config.apiUrl}/personnel/${userId}/events`);
  }

  static sendEmail(emailContent) {
    return http.post(`${Config.apiUrl}/salesforce`, emailContent);
  }
}

export default SendEmailService;
